import { render, staticRenderFns } from "./serveCity.vue?vue&type=template&id=619a0224&scoped=true&"
import script from "./serveCity.vue?vue&type=script&lang=js&"
export * from "./serveCity.vue?vue&type=script&lang=js&"
import style0 from "./serveCity.vue?vue&type=style&index=0&id=619a0224&scoped=true&lang=css&"
import style1 from "./serveCity.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619a0224",
  null
  
)

export default component.exports